export class LocalItem {
  key: string
  public constructor(key: string) {
    this.key = key
  }
  get(): string | null {
    return localStorage.getItem(this.key)
  }
  set(data: string): void {
    localStorage.setItem(this.key, data)
  }
  reset(): void {
    localStorage.removeItem(this.key)
  }
}

export const LocalToken = new LocalItem("token")
export const LocalTheme = new LocalItem("theme")
export const LocalDefaultTheme = new LocalItem("defaultTheme")
export const LocalForceShow = new LocalItem("forceShow")
